import React from 'react';
import Head from 'next/head';
import { removeTrailingSlash } from '@requity-homes/utils';
import { SignInForm } from '@requity-homes/component-library';

export default function SignInPage() {
  const url = `${removeTrailingSlash(
    process.env.NEXT_PUBLIC_AUTH_API_URL,
  )}/login`;

  return (
    <>
      <Head>
        <title>Client Log-In | Requity Homes</title>
        <meta
          name="description"
          content="Access your Requity Homes client portal. Sign in to manage your rent-to-own agreement, view property details, and track your home ownership progress."
        />
      </Head>
      <SignInForm url={url} />
    </>
  );
}
